import React, { useEffect, useState } from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import "./App.css";
import Navigation from "./navigator/Navigation";

import { loadUser } from "./store/actions/authActions";
import { loadRecentlyViewedProducts } from "./store/actions/recentViewedProductsActions";

import "./App.css";
import AuthModal from "./components/Auth/AuthModal";
import MoveTop from "./components/Common/MoveTop";
import MainLayout from "./layout/MainLayout";
import { useDispatch } from "react-redux";
// import SideCartModal from "./components/Cart/SideCartModal";
import {Helmet} from "react-helmet";
import { useLocation, useSearchParams } from 'react-router-dom';
import { appGetSEODetails } from "./services/PageServices.js";
import { USER_KEY } from "./utils/Constant.js";
import { initPixel } from "./utils/PixelEvents/FacebookEvents.js";

function App() {
  const dispatch = useDispatch();
  const [seoDetails, setSeoDetails] = useState({});
  // Added by Anurag Chauhan on 24-07-2025 to save the utmsource for Rakuten.
  const [searchParams] = useSearchParams();
  const [utmSource , setUtmSource] = useState(searchParams?.get("utm_source") || "");
  const [utmCampaign , setUtmCampaign] = useState(searchParams?.get("utm_campaign") || "");
  const [utmMedium , setUtmMedium] = useState(searchParams?.get("utm_medium") || "");
  const [gadSource , setGadSource] = useState(searchParams?.get("gad_source") || "");
  const [gadCampaign , setGadCampaign] = useState(searchParams?.get("gad_campaignid") || "");

  if( utmSource !== "" ){
    localStorage.setItem('Utm_source' , utmSource.toLowerCase());
    setUtmSource("");
  }
  if( utmCampaign !== "" ){
    localStorage.setItem('Utm_campaign' , utmCampaign.toLowerCase());
    setUtmCampaign("");
  }
  if( gadSource !== "" ){
    localStorage.setItem('Utm_source' , 'google_ads');
    setGadSource("");
  }
  if( gadCampaign !== "" ){
    localStorage.setItem('Utm_campaign' , gadCampaign.toLowerCase());
    setGadCampaign("");
  }
  if( utmMedium !== "" ){
    localStorage.setItem('Utm_medium' , utmMedium.toLowerCase());
    setUtmMedium("");
  }

  dispatch(loadUser());
  dispatch(loadRecentlyViewedProducts());
  // let response = {};
  const location = useLocation();

  /**
   * Fetching SEO meta data
   */
  useEffect(() => {
    let savedUser = localStorage.getItem(USER_KEY);
    savedUser = savedUser ? JSON.parse(savedUser) : null;
    initPixel(savedUser);
    appGetSEODetails({
      page_url: location.pathname
    }).then((res) => {
      let response = JSON.parse(res?.data);
      setSeoDetails(response.data);
    });
  }, [location]);

  return (
    <div className="App">
      <Helmet>
        <meta name="keywords" content={seoDetails.keywords} />
        <meta name="description" content={seoDetails.meta_desc} />
        <meta name="robots" content={seoDetails.robots} />
        <link rel="canonical" href={seoDetails.canonical_url} />
        <title>{seoDetails.title}</title>
      </Helmet>
      <ToastContainer
        theme="colored"
        position="top-right"
        autoClose={5000}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        // pauseOnFocusLoss
        draggable
        pauseOnHover
        style={{ position: "fixed", zIndex: "99999999999" }}
        // limit={1}
      />

      <AuthModal />
      {/* <SideCartModal /> */}
      {/* Routing Section */}
      {/* <MainLayout > */}
      <MainLayout seoDetails={seoDetails} >
        <Navigation />
      </MainLayout>

      <MoveTop />
    </div>
  );
}

export default App;
